module.exports = __webpack_public_path__ + "img/img1.90bd33b9.png";